import { render, staticRenderFns } from "./registration-by-email.vue?vue&type=template&id=08463212"
import script from "./registration-by-email.vue?vue&type=script&lang=js"
export * from "./registration-by-email.vue?vue&type=script&lang=js"
import style0 from "./registration-by-email.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-email.vue
// module id = 9g27
// module chunks = 0